((win, doc) => {
  function setRemUnit() {
    const docEl = document.documentElement;
    const { clientWidth } = docEl;
    if (!clientWidth) {
      return;
    }
    let calcWidth = clientWidth;
    if (calcWidth > 1920) {
      calcWidth = 1920;
    }
    const fontSize = calcWidth / 19.2; // 1920 尺寸
    docEl.style.fontSize = `${fontSize}px`;
  }
  setRemUnit();
  doc.addEventListener('DOMContentLoaded', setRemUnit, false);
  win.addEventListener('resize', setRemUnit, false);
  win.addEventListener('load', setRemUnit, false);
  win.addEventListener('orientationchange', setRemUnit);
  win.addEventListener('visibilitychange', setRemUnit);
})(window, document);
